export default "__VITE_ASSET__CWKk3TXw__"